/*
 Note: changing "icon_button__icon" could affect tracking.
 (see https://notonthehighstreet.atlassian.net/browse/FFA-514?focusedCommentId=54133)
 */

/** @deprecated Ribbons consumers should not rely on a Ribbons component's internal implementation details */
export const ICON_BUTTON__ICON_CLASS = 'icon_button__icon';

/** @deprecated Ribbons consumers should not rely on a Ribbons component's internal implementation details */
export const ICON_BUTTON__BUTTON_CLASS = 'icon_button__button';
